// src/hooks/useProductType.ts
import { useMemo } from "react";
import { useAppData, AppData } from "@/store/appStore";
import {
	getAllowedProductTypes,
	getEffectiveProductType,
} from "@/lib/utils/productType";

export function useEffectiveProductType(): ProductType {
	const [appData] = useAppData();
	const { showCar, showDevice, onboardingCompletionType } = appData;

	return useMemo(
		() =>
			getEffectiveProductType({
				showCar,
				showDevice,
				onboardingCompletionType,
			} as AppData),
		[showCar, showDevice, onboardingCompletionType],
	);
}

export function useAllowedProductTypes(): ProductType[] {
	const [appData] = useAppData();
	const { showCar, showDevice } = appData;

	return useMemo(
		() => getAllowedProductTypes({ showCar, showDevice } as AppData),
		[showCar, showDevice],
	);
}
